import { FieldFunctionOptions } from '@apollo/client';

import { NotesQuery } from '../../types/api.graphql';

type NotesType = NotesQuery['notes'];

export const mergeNotesCache = (
  existing: NotesType = undefined,
  incoming: NotesType,
  { readField }: FieldFunctionOptions,
) => {
  {
    if (!incoming?.nodes) {
      return {};
    }
    const existingNodes = existing?.nodes || [];

    // If a note was deleted from the cache, we should only keep the incoming nodes
    const removedNodes = existingNodes.filter(
      (node: any) =>
        !incoming.nodes.find(
          (oldNode: any) => readField<string>('id', node)?.toString() === readField<string>('id', oldNode)?.toString(),
        ),
    );
    if (removedNodes.length === 1) {
      return {
        ...incoming,
        nodes: [...incoming.nodes],
      };
    }

    const newNodes = incoming?.nodes?.filter(
      (node: any) =>
        !existingNodes.find(
          (oldNode: any) => readField<string>('id', node)?.toString() === readField<string>('id', oldNode)?.toString(),
        ),
    );

    if (newNodes.length === 1) {
      // If there is only one item without pageInfo
      // we can consider it is a new notification comming from a subscription
      // so we added it to the top of the list

      return {
        ...existing,
        ...incoming,
        nodes: [...newNodes, ...existingNodes],
        pageInfo: incoming.pageInfo,
      };
    }

    const newData = {
      ...existing,
      ...incoming,
      nodes: [...existingNodes, ...newNodes],
      pageInfo: incoming.pageInfo,
    };

    return newData;
  }
};
